import Enum from "../../../../../enums/Enum";

const EnumPackageStatus = new Enum({
    PENDING: "Pending",
    BILLED: "Billed",
    REFUNDED: "Refunded",
    PENDING_SIGNATURE: "Pending Signature",
    PENDING_PAYMENT: "Pending Payment",
    ACTIVE: "Active",
    COMPLETED: "Completed"
});

export default EnumPackageStatus; 